import { useContext } from "react";
import { useStore } from "zustand";
import { useShallow } from "zustand/shallow";

import { ActivityTabsStoreType } from "./activity_tabs_store.types";
import { ActivityTabsStoreContext } from "./activity_tabs_store_context";

export const useActivityTabsStore = <U>(selector: (state: ActivityTabsStoreType) => U) => {
  const store = useContext(ActivityTabsStoreContext);
  return useStore(store, useShallow(selector));
};

export const useActivityTabsStoreActions = () => {
  const store = useContext(ActivityTabsStoreContext);
  return useStore(store, (state) => state.actions);
};
